import { NzModalService } from 'ng-zorro-antd/modal';
import { LayoutService } from 'src/app/layout/layout.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-inbound-bin',
  templateUrl: './inbound-bin.component.html',
  styleUrls: ['./inbound-bin.component.less'],
})
export class InboundBinComponent implements OnInit {
  @Input() requiredQty = 0;

  binLocationDataVal = [];
  @Input() set binLocationData(val: any[]) {
    this.binLocationDataVal = val;
    this.visibleBinLocations = val;
    this.binSearchValue = '';
  }

  get binLocationData(): any[] {
    return this.binLocationDataVal;
  }

  @Output() binLocationDataChange = new EventEmitter();

  @Input() selectedQty = 0;
  @Output() selectedQtyChange = new EventEmitter<number>();

  binSearchValue = '';
  visibleBinLocations = [];

  constructor(
    private layoutService: LayoutService,
    private modalService: NzModalService,
    private messageService: NzMessageService
  ) {}

  ngOnInit(): void {
    this.visibleBinLocations = this.binLocationData;
  }

  searchForBin() {
    this.visibleBinLocations = this.binLocationData.filter((b) => {
      return (
        b.BinCode.toLowerCase().indexOf(this.binSearchValue.toLowerCase()) !==
        -1
      );
    });
  }

  allocateToDefaultBin() {
    this.binLocationData.forEach((bin) => {
      if (bin.IsDefault === 'Y') {
        if (this.selectedQty >= this.requiredQty) {
          this.modalService.error({
            nzTitle: this.layoutService.translate(
              'You have allocated all items, do you want to reset the allocation and put everything in default bin location?'
            ),
            nzOkText: this.layoutService.translate('Yes'),
            nzCancelText: this.layoutService.translate('Cancel'),
            nzOnCancel: () => {},
            nzOnOk: () => {
              this.binLocationData.forEach((b) => {
                b.SelectedQuantity = 0;
              });
              bin.SelectedQuantity = this.requiredQty;
              this.selectedQty = this.requiredQty;
            },
          });
        } else {
          bin.SelectedQuantity = this.requiredQty - this.selectedQty;
          this.selectedQty = this.requiredQty;
        }
      }
    });

    this.selectedQtyChange.emit(this.selectedQty);
    this.binLocationDataChange.emit(this.binLocationData);
  }

  binQuantitySelected(selectedBin) {
    this.selectedQty = 0;
    this.binLocationData.forEach((bin) => {
      if (
        bin.SelectedQuantity === 0 ||
        bin.SelectedQuantity === undefined ||
        bin.SelectedQuantity === '' ||
        Number(bin.SelectedQuantity) === 0
      ) {
        return;
      }

      this.selectedQty += Number(bin.SelectedQuantity);
    });

    if (this.selectedQty > this.requiredQty) {
      /*this.messageService.error(
        this.layoutService.translate(
          'Selected quantity exceeds the required quantity, we reset the quantity to the maximum allowed quantity.'
        )
      );*/

      this.requiredQty = this.selectedQty;

      selectedBin.SelectedQuantity =
        selectedBin.SelectedQuantity - (this.selectedQty - this.requiredQty);
      this.selectedQty = this.requiredQty;
    }

    this.selectedQtyChange.emit(this.selectedQty);
    this.binLocationDataChange.emit(this.binLocationData);
  }
}
